define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("personalization-web-agent-templates/widget-templates/widget-organize/widgetOrganize.tmpl");

    var WidgetOrganizeItemView = require("personalization-web-agent-views/widget-views/widget-organize/WidgetOrganizeItemView");

    var Button = require("ui/button/Button");
    var List = require("ui/list/List");

    var WidgetModel = require("personalization-web-agent-models/WidgetModel");

    var widgetOrganizeView = {};

    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        widgetOrganizeView = Marionette.CompositeView.extend({
            className: "widget-organize",
            template: template,
            itemView: WidgetOrganizeItemView,
            itemViewEventPrefix: "item",
            itemViewContainer:".widget-organize-list-container tbody",
            ui: {
                doneButton: ".organize-widget-done",
                widgetOrganizeListContainer: ".organize-widget-list"
            },
            uiComponents: {
                doneButton: {
                    type: Button,
                    options: {
                        el: "view.ui.doneButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onDoneClick"
                    }
                }
            },
            events: {
                "click .organize-widget-close-btn": "_onCloseButtonClick",
                "click .advanced-settings-container.field-title-collapsible": "_onAdvancedSettingsClick"
            },

            /************************** Marionette overriden functions *****************************************/
            initialize: function (options) {
                LEPersonalization.logger.info("Initializing widgetOrganizeView", "widgetOrganizeView:initialize");
                this.vent = options.vent;
                this.collection = options.collection;

                this.itemViewOptions = {
                    vent : this.vent
                };
            },

            /************************** private functions *****************************************************/

            _onCloseButtonClick: function () {
                this.vent.trigger("widget-organize:cancel");
            },

            _onDoneClick: function() {
                this.vent.trigger("widget-organize:done");
            }

        });
    });
    return widgetOrganizeView;
});


